(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(64796);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77149);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19453);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92757);
/* harmony import */ var _dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_9__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-x: clip;\n\n  + div #detail-page-wrapper {\n    ",
        " {\n      top: ",
        ";\n    }\n\n    ",
        " {\n      top: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var DynamicMarquee = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 17566, 23)).then(function(mod) {
        return mod.Marquee;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17566)
            ];
        }
    },
    ssr: false
});
var DynamicSectionHighlights = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 21535)).then(function(mod) {
        return mod.SectionHighlights;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21535)
            ];
        }
    }
});
var DynamicSectionBestseller = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80874)).then(function(mod) {
        return mod.SectionBestseller;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80874)
            ];
        }
    }
});
var DynamicSubscribe = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3292)).then(function(mod) {
        return mod.Subscribe;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3292)
            ];
        }
    }
});
var HomePage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var data = param.data;
    var seo = data.seo, _banners = (0,_swc_helpers_src_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(data.banners), header = _banners[0], productHighlighted = _banners.slice(1), topSellers = data.topSellers, highlighted = data.highlighted, brands = data.brands, services = data.services;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var scrollPos = (0,_dy_commons_hooks__WEBPACK_IMPORTED_MODULE_5__.useScrollTracker)(1);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: locale === "en-EU" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__.SectionStorePicker, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_6__.HeadTag, {
                    seo: seo,
                    jsonld: {
                        data: data,
                        pageType: "home"
                    },
                    pageType: "home"
                }),
                header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__.HeaderHome, {
                    data: header
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                    $scrollTop: scrollPos === "TOP",
                    children: [
                        _dy_commons_utils__WEBPACK_IMPORTED_MODULE_8__.DY_SIGNUP_ALLOWED && (locale === "es-CT" || locale === "es-MD") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicSubscribe, {}),
                        highlighted.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicSectionBestseller, {
                            data: {
                                topSellers: topSellers,
                                highlighted: highlighted
                            }
                        }),
                        productHighlighted.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicSectionHighlights, {
                            data: productHighlighted
                        }),
                        brands.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_7__.SectionBrands, {
                            brands: brands
                        }),
                        services && Object.keys(services).length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DynamicMarquee, {
                            data: services.title
                        })
                    ]
                })
            ]
        })
    });
});
HomePage.Layout = _components__WEBPACK_IMPORTED_MODULE_7__.LayoutEmpty;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HomePage);
var Main = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].main.withConfig({
    displayName: "pages__Main",
    componentId: "sc-6d9ab8b4-0"
})(_templateObject(), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_9__.mq.greaterThan("tablet"), function(param) {
    var $scrollTop = param.$scrollTop;
    return (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_9__.vw)($scrollTop ? 85 : 45, "desktop");
}, _dy_commons_styles__WEBPACK_IMPORTED_MODULE_9__.mq.greaterThan("desktop"), function(param) {
    var $scrollTop = param.$scrollTop;
    return $scrollTop ? 85 : 45;
});


/***/ }),

/***/ 77149:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18770);
/* harmony import */ var _iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33579);
/* harmony import */ var _non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93520);
/* harmony import */ var _unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15459);





function _toArray(arr) {
  return (0,_array_with_holes_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupported_iterable_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr, i) || (0,_non_iterable_rest_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);